import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { NavigationHistoryStateController } from './navigationHistoryState.component';

const states: Ng1StateDeclaration[] = [{
    name: 'navigationHistory',
    url: '/navigationHistory/:index',
    controller: NavigationHistoryStateController,
    controllerAs: 'vm',
    abstract: false,
    resolve: {
        auth: Resolve.authResolve,
        connected: Resolve.connectedResolve
    },
    params: {
        index: ''
    },
    data: {
        ignoreHistory: true
    }
}];

export default states;